import React, { ReactNode, useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Icon from '@amzn/meridian/icon';
import Text from '@amzn/meridian/text';
import Popover, { PopoverHeader } from '@amzn/meridian/popover';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import styles from './MoreInfoIcon.module.css';
interface MoreInfoProps {
  category: string;
  processName?: string;
  concessionFeedbackCommentText?: string;
}
const MoreInfoIcon: React.FC<MoreInfoProps> = ({
  category,
  processName,
  concessionFeedbackCommentText,
}) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef();
  const onClickButton = () => setOpen(true);
  const onClose = () => setOpen(false);
  const buttonTestId = `popover-button-more-info-icon`;
  const popoverTestId = `popover-shown-more-info-icon`;
  const intl = useIntl();
  const POPOVER_MAX_WIDTH = 600;
  return (
    <React.Fragment>
      <div style={{ display: 'inline' }}>
        {category}
        <Button
          data-testid={buttonTestId}
          onClick={onClickButton}
          ref={buttonRef}
          type='icon'
          circular
          size='small'
          className={styles.infoIconButton}
        >
          <Icon tokens={infoKnockoutTokens}></Icon>
        </Button>
      </div>
      <div className={styles.popoverDisplay}>
        <Popover
          anchorNode={buttonRef.current}
          open={open}
          onClose={onClose}
          position='bottom'
        >
          <PopoverHeader
            closeLabel={intl.formatMessage({
              id: 'cs_perfportal_popover_close',
              defaultMessage: 'close',
            })}
          >
            <Text type='h200'>{category}</Text>
          </PopoverHeader>
          <Column>
            {processName && (
              <Row width='100%' maxWidth={POPOVER_MAX_WIDTH}>
                <Text>
                  <strong>
                    <FormattedMessage
                      id='cs_perfportal_concession_compliance_process_name'
                      defaultMessage='Process name'
                    />
                  </strong>{' '}
                  {processName}
                </Text>
              </Row>
            )}
            <div data-testid={popoverTestId} hidden></div>
            {concessionFeedbackCommentText && (
              <Row width='100%' maxWidth={POPOVER_MAX_WIDTH}>
                <div className={styles.popoverDisplay}>
                  <Text className={styles.wrapText}>
                    <strong>
                      <FormattedMessage
                        id='cs_perfportal_concession_compliance_feedback_comment'
                        defaultMessage='Feedback comment'
                      />
                    </strong>{' '}
                    {concessionFeedbackCommentText}
                  </Text>
                </div>
              </Row>
            )}
            <Row alignmentHorizontal='center'>
              <Button type='primary' onClick={onClose}>
                <FormattedMessage
                  id='cs_perfportal_popover_close'
                  defaultMessage='close'
                />
              </Button>
            </Row>
          </Column>
        </Popover>
      </div>
    </React.Fragment>
  );
};

export default MoreInfoIcon;
